import { useEffect, useState } from "react";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-cream/85 backdrop-blur-md border-b border-clay/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-6xl mx-auto flex items-center justify-between px-6 py-4">
        <a href="#" data-testid="nav-logo" className="font-script text-3xl text-clay leading-none">
          E & J
        </a>
        <div className="hidden md:flex items-center gap-10 text-[11px] uppercase tracking-[0.25em] text-ink/70">
          <a data-testid="nav-link-historia" href="#historia" className="hover:text-clay transition-colors">Historia</a>
          <a data-testid="nav-link-detalles" href="#detalles" className="hover:text-clay transition-colors">Detalles</a>
          <a data-testid="nav-link-fotos" href="#fotos" className="hover:text-clay transition-colors">Fotos</a>
          <a data-testid="nav-link-admin" href="/admin" className="hover:text-clay transition-colors">Admin</a>
        </div>
        <a
          data-testid="nav-rsvp-button"
          href="#rsvp"
          className="rounded-full bg-clay text-cream text-[11px] uppercase tracking-[0.2em] px-6 py-3 hover:bg-clay-deep transition-colors"
        >
          RSVP
        </a>
      </nav>
    </header>
  );
};
